import { MultiLingualTextInput } from './component';

export * from './component';
export default MultiLingualTextInput;
